module.exports = __webpack_public_path__ + "static/media/poor-selected.a903e19e.svg";